/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} P1portal_Sidebar_Drawer_ScrimInputs */



/**
* | output |
* | --- |
* | "Close the menu" |
*
* @param {P1portal_Sidebar_Drawer_ScrimInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const p1portal_sidebar_drawer_scrim = /** @type {((inputs?: P1portal_Sidebar_Drawer_ScrimInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<P1portal_Sidebar_Drawer_ScrimInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Close the menu")
});